import _ from 'lodash'
import { io } from './io'
import { instana } from './instana'
import { Monitoring } from './types'

const monitoring: Monitoring = _.isEqual(window.ENV.REACT_APP_DEBUG_MODE, 'on') ? io : instana

export { monitoring as Monitoring }
